import { render, staticRenderFns } from "./MultiDeptHelpList.vue?vue&type=template&id=d6c75e68&"
import script from "./MultiDeptHelpList.vue?vue&type=script&lang=js&"
export * from "./MultiDeptHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports